import {
  AmendmentSubclause,
  DocumentAmendment,
} from "common/flowmaster/types/amendment";

function levelFields(
  subclause: AmendmentSubclause,
): Partial<DocumentAmendment> {
  if (subclause.unnumbered === "true") {
    return {
      detachFromList: true,
      listLevel: undefined,
      matchParentClauseIndent: true,
    };
  }
  return {listLevel: parseInt(String(subclause.level), 10)};
}

export function generateSubclauseAmendments(
  amendment: DocumentAmendment,
): DocumentAmendment {
  const subclauses = amendment.subclauses ?? [];
  const subAmendments: DocumentAmendment[] = [];
  const seenRefs = new Set<string>();

  for (let idx = 0; idx < subclauses.length; idx++) {
    const subclause = subclauses[idx];
    const ref = subclause.target_clause_reference;
    const isRepeatRef = ref !== undefined && seenRefs.has(ref);
    if (ref !== undefined) {
      seenRefs.add(ref);
    }

    if (idx === 0) {
      subAmendments.push({
        ...amendment,
        added_text: subclause.added_text,
        target_clause_reference: subclause.target_clause_reference,
        ...levelFields(subclause),
        subclauses: undefined,
      });
    } else {
      subAmendments.push({
        ...amendment,
        action_type: "insert_after",
        added_text: subclause.added_text,
        target_clause_reference: subclause.target_clause_reference,
        before_text: subclauses[idx - 1].added_text,
        after_text: amendment.after_text,
        deleted_text: "",
        comment: undefined,
        ...(isRepeatRef
          ? {detachFromList: true, listLevel: undefined}
          : levelFields(subclause)),
        subclauses: undefined,
      });
    }
  }

  return {
    ...amendment,
    subAmendments,
  };
}
